import { gql } from "graphql-request";
import * as z from "zod";

import {
  EsportCarouselLiveEntrySchema,
  EsportCarouselLiveEntryFragment,
} from "./esportCarouselLiveEntry";

import {
  EsportCarouselEventEntrySchema,
  EsportCarouselEventEntryFragment,
} from "./esportCarouselEventEntry";

import { Sys, SysFragment } from "../sys";
import { Targeting, TargetingFragment } from "../targeting";
import { RelatedMedia, RelatedMediaFragment } from "../relatedMedia";

export const EsportCarouselEntrySchema = z.object({
  sys: Sys,
  sortDate: z.string().nullable(),
  targeting: Targeting.nullish(),
  relatedMedia: RelatedMedia.nullish(),
  localized: z
    .discriminatedUnion("__typename", [
      EsportCarouselLiveEntrySchema,
      EsportCarouselEventEntrySchema,
    ])
    .nullish(),
});

export const EsportCarouselEntry = EsportCarouselEntrySchema;
export type EsportCarouselEntry = z.infer<typeof EsportCarouselEntrySchema>;

export const EsportCarouselEntryFragment = gql`
  fragment EsportCarouselEntryFragment on EsportCarouselEntry {
    sys {
      ...SysFragment
    }
    sortDate
    targeting {
      ...TargetingFragment
    }
    relatedMedia {
      ...RelatedMediaFragment
    }
    localized {
      ... on EsportCarouselEventEntry {
        ...EsportCarouselEventEntryFragment
      }
      ... on EsportLiveEventEntry {
        ...EsportCarouselLiveEntryFragment
      }
    }
  }

  ${EsportCarouselLiveEntryFragment}
  ${EsportCarouselEventEntryFragment}
  ${SysFragment}
  ${TargetingFragment}
  ${RelatedMediaFragment}
`;
